/**** mgt.TransportType */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'TransportType',
  title: 'Типы транспортных средств',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'title',
      title: 'Наименование',
      type: 'text',
      required: true,
    },
    {
      name: 'note',
      title: 'Обозначение',
      type: 'text',
      required: true,
    },
  ],
  newTemplate: {
    id: null,
    title: '',
    note: '',
  },
  updateField: 'update_date',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'ts_type_id',
        field: 'id',
      },{
        title: 'ts_type_full_name',
        field: 'title',
      },
      {
        title: 'ts_type_short_name',
        field: 'note',
      }
    ],
    example: `1;Автобус;A`,
  },
  export: {
    fields: [
      {
        name: 'title',
        title: 'Наименование',
      },
      {
        name: 'note',
        title: 'Обозначение',
      },
    ],
  },
};

export default config;
